
import { useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import Box from '@mui/material/Box';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';
import { NavSectionProps, NavSectionVertical } from '../nav-section';
import { Scrollbar } from '../scrollbar';
import { usePathname } from 'next/navigation';
import { selfUrlToHomeHref } from '@/lib/appBasePath';

type NavMobileProps = NavSectionProps & {
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
};

export function NavMobile({ data, open, onClose, slots, sx, ...other }: NavMobileProps) {
  const theme = useTheme();
  const pathname = usePathname();
  const appUrl = process.env.NEXT_PUBLIC_SELF_URL;


  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          overflow: 'unset',
          bgcolor: 'var(--layout-nav-bg)',
          backgroundImage: 'none',
          width: 'var(--layout-nav-vertical-width)',
          ...sx,
        },
      }}
    >
      {slots?.topArea ?? (
        <Box sx={{ pl: 2.8, pt: 2.5, pb: 2.5 }}>
          <Link href={selfUrlToHomeHref(appUrl)} style={{ display: 'inline-flex' }}>
            <Image
              alt="boostt.ai logo"
              src={theme.palette.mode === 'dark' ? "/v2/images/logo-on-dark.png" : "/v2/images/boosttai.png"}
              width={140}
              height={35}
              style={{ objectFit: 'contain' }}
            />
          </Link>
        </Box>
      )}

      <Scrollbar fillContent>
        <NavSectionVertical data={data} sx={{ px: 2, flex: '1 1 auto' }} {...other} />
        {/* <NavUpgrade /> */}
      </Scrollbar>

      {slots?.bottomArea}
    </Drawer>
  );
}
